import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import useModal from "../../custom_hooks/useModal";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import "./InvoiceFormat.scss";

import { getBranchCode, getCompanyCode, getLicenseeCode } from "../../../CommonFunction/GetUserInfo";
import { getFormKeyByTitle, getQueryNameByTitle } from "./invoiceHelpers";
import SideLayoutPdf from "./SideLayoutPdf";
import { EditPreference } from "../../../Utils/AllPagesQuriesAndMutations";
import { useMutation } from "@apollo/client";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/print/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import { printPlugin } from "@react-pdf-viewer/print";
import { memo, useMemo } from "react";
import mergeBlobsToPdf from "./MergeBlobs";

// NEW ────────────────────────────────────────────────
const PdfCard = memo(function PdfCard({ doc }) {
  // one static print plugin for this card
  const printPluginInstance = useMemo(() => printPlugin(), []);
  const { Print } = printPluginInstance;

  // 2) Our custom print handler:
  const handleNativePrint = () => {
    // create a one-off object URL
    // inject a hidden iframe
    const container = document.querySelector(".invoice_Format_container");
    if (!container) return;

    container.innerHTML = ""; // clear anything in the portal
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = doc.url;
    container.appendChild(iframe);

    // once loaded, trigger print
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };
  };
  // file plugin depends on filename
  const filePluginInstance = useMemo(
    () =>
      getFilePlugin({
        fileNameGenerator: () => doc.filename,
      }),
    [doc.filename]
  );
  const { DownloadButton } = filePluginInstance;

  return (
    <div style={{ marginBottom: 24 }}>
      <div className="invoice-toolbar">
        <button onClick={handleNativePrint}>Print</button>
        <DownloadButton />
      </div>
      <Viewer fileUrl={doc.url} plugins={[printPluginInstance, filePluginInstance]} />
    </div>
  );
});
const InvoiceFormat = ({
  show,
  title,
  TypeOfPortal,
  ParentPortalCloseFunction,
  id,
  TableKey,
  triggerPrint,
  defaultLayout = "",
}) => {
  // Derive keys from your helper functions
  const Form_Key = getFormKeyByTitle(TableKey);
  const queryName = getQueryNameByTitle(TableKey);
  const { isOpenModal, onOpenModal, onCloseModal } = useModal();
  const { isOpenModal: openDetails, onOpenModal: onDetailsModal, onCloseModal: onDetailsClose } = useModal();
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [loading, setLoading] = useState(true);
  const [DefaultFormData, setDefaultFormData] = useState();
  const [partyEmail, setPartyEmail] = useState("yasim.jamadar@headtler.com");
  // one state for { id: string; blob: Blob; url: string; filename: string }//
  const [docs, setDocs] = useState([]);

  const [EditSetUpPreference] = useMutation(EditPreference);
  const [layoutoptions, setLayout] = useState({
    layout: defaultLayout ? defaultLayout : "Layout-1",
    copies: 1,
    type: "print",
  });
  // console.log(layoutoptions, "valuevaluevaluevalue");
  const UniqueTableReducerStore = useSelector((store) => store.UniqueTableReducer);
  //new varable SelectMulitple  Rows is arry of ids example["qwww","qqwww", "qwwwqwe"]
  const ids = id ? [id] : UniqueTableReducerStore[Form_Key]?.SelRows_ids;

  
  useEffect(() => {
    return () => docs.forEach((d) => URL.revokeObjectURL(d.url));
  }, [docs]);

  const closeModelFunction = () => {
    ParentPortalCloseFunction();
    onCloseModal();
  };
  const closeDetailsModal = () => {
    onDetailsClose();
    ParentPortalCloseFunction();
  };

  const SavePreference = () => {
    let layoutObj = FormDataFromRedux?.MasterData["SideLayoutPdf"]?.layout;
    EditSetUpPreference({
      variables: {
        userInput: {
          Form_Key: Form_Key,
          printConfigurationData: {
            Default_Layout: layoutObj,
            Default_Copies: DefaultFormData?.copies,
            Default_Type: DefaultFormData?.type,
          },
        },
      },
    }).then((res) => {
      SuccessToast("Configuration Updated Successfuly");
    });
  };

  const handlechangelayout = (value) => {
    setLayout(value);
  };
  // Handle printing the PDF
  const handlePrintPdf = async () => {
    const { layout, copies, type } = layoutoptions;
    const licenseeCode = await getLicenseeCode();
    const { CompanyCode } = await getCompanyCode();
    const { BranchCode } = await getBranchCode();
    try {
      const fetchOne = (singleId) =>
        axios.get(`${process.env.REACT_APP_BILL_GENERATE_BACKEND}/${queryName}`, {
          params: { Id: singleId, type, partyEmail, layout },
          headers: { licenseecode: licenseeCode, companycode: CompanyCode, branchcode: BranchCode },
          responseType: "arraybuffer",
        });
      const responses = await Promise.all(ids?.map(fetchOne));

      const newDocs = responses.map((res, idx) => {
        // ── filename from Content-Disposition
        const cd = res.headers["content-disposition"];
        let filename = `${title}_${ids[idx]}.pdf`;
        if (cd) {
          const m = cd.match(/filename="([^"]+)"/);
          if (m) filename = m[1];
        }

        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        // auto-download if user chose "pdf" mode
        if (type === "pdf") {
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        }

        return { id: ids[idx], blob, url, filename };
      });

      setDocs(newDocs); // <-- update state

      if (type === "print") {
        // extract all the individual blobs
        const blobs = newDocs.map((d) => d.blob);
        // merge them
        const merged = await mergeBlobsToPdf(blobs);

        // create a one-off object URL
        const url = URL.createObjectURL(merged);

        // inject a hidden iframe
        const container = document.querySelector(".invoice_Format_container");
        if (!container) return;

        container.innerHTML = ""; // clear anything in the portal
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;
        container.appendChild(iframe);

        // once loaded, trigger print
        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          // clean up after printing
          setTimeout(() => {
            // URL.revokeObjectURL(url);
            // container.removeChild(iframe);
            // closeModelFunction();
          }, 500);
        };
      }
    } catch (err) {
      console.error(err);
      ErrorToast("Failed to fetch one or more invoices.");
    } finally {
      setLoading(false);
    }
  };

  // Trigger fetching and printing of invoice data when modal is opened
  useEffect(() => {
    if (show && !triggerPrint) {
      // onOpenModal();
      // handlePrintPdf();
      onDetailsModal();
    }
  }, [show]);
  useEffect(() => {
    if (triggerPrint) {
      (async () => {
        onOpenModal();
        await handlePrintPdf();
        // onDetailsClose();
      })();
    }
  }, [triggerPrint]);

  const footerContent = (
    <PortalFooter renderContent={() => <></>} disabled={false} handleformclose={closeModelFunction} />
  );
  const footerContentDetails = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      handleformclose={() => {
        onDetailsClose();
        ParentPortalCloseFunction();
      }}
      submitType={"Print"}
      submitform={async () => {
        await onOpenModal();
        handlePrintPdf();
        onDetailsClose();
      }}
      setDefaultPrint={true}
      openPrefFun={() => SavePreference()}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={isOpenModal}
          onClose={closeModelFunction}
          TypeOfPortal={TypeOfPortal}
          Form_Key={Form_Key}
          idTitle={"Sales Bill ID"}
        >
          <div className="doc-viewer" style={{ height: "80vh", width: "60vw", overflowX: "scroll" }}>
            {docs.length > 0 /* same portal wrapper you already have */ && (
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                {docs.map((doc) => (
                  <PdfCard key={doc.id} doc={doc} />
                ))}
              </Worker>
            )}
            <div className="invoice_Format_container" />
          </div>
        </Reactportal>
        {openDetails && (
          <Reactportal
            FoooterContent={footerContentDetails}
            open={openDetails}
            onClose={closeDetailsModal}
            TypeOfPortal={TypeOfPortal + " Details"}
            Form_Key={Form_Key}
            idTitle={"Sales Bill ID"}
          >
            <div className="details_invoice_container">
              <SideLayoutPdf
                handlechangelayout={handlechangelayout}
                Table_Key={TableKey}
                setDefaultFormData={setDefaultFormData}
                mainFormKey={Form_Key}
                ParentPortalCloseFunction={ParentPortalCloseFunction}
              />
            </div>
          </Reactportal>
        )}
      </div>
      {}
    </>
  );
};

export default InvoiceFormat;
